/** Dropdown options for labour stack-width / carry-distance surcharge tiers. */

export function labourTierSelectOptions(tiers, { withinLabel = "Within limit (1×)" } = {}) {
  const opts = [{ value: "BASE", label: withinLabel }];
  (tiers || []).forEach((tier, i) => {
    const mult = Number(tier.multiplier) || 1;
    const label = tier.label?.trim()
      || (tier.excess != null && tier.excess !== ""
        ? `Tier ${i + 1} — +${tier.excess} (${mult}×)`
        : `Surcharge tier ${i + 1} (${mult}×)`);
    opts.push({ value: String(i + 1), label });
  });
  return opts;
}

export function labourTierLabel(tierKey, tiers) {
  const opts = labourTierSelectOptions(tiers);
  return opts.find((o) => o.value === String(tierKey || "BASE"))?.label || "Within limit";
}
